import styles from './logo-link.module.css';

import Link from 'next/link';
import Image from 'next/image';
import { ThemeMode } from '@/app/lib/schemas/types/shared';
import { AspectRatio, Box } from '@radix-ui/themes';
import { LOGO_ASPECT_RATIO } from '@/app/lib/constants/sizes';

interface Props {
  theme: ThemeMode;
  height: number;
}

export default function LogoLink({ theme, height }: Props) {
  return (
    <Box
      width={`${LOGO_ASPECT_RATIO * height}px`}
      height={`${height}px`}
      className={styles.Logo}
    >
      <Link
        href='/'
        passHref
      >
        <AspectRatio ratio={LOGO_ASPECT_RATIO}>
          <Box
            position='relative'
            width='100%'
            height='100%'
          >
            <Image
              src={
                theme === 'light'
                  ? '/images/logo-light.svg'
                  : '/images/logo-dark.svg'
              }
              alt='Logo'
              fill
              sizes='144px, 36px'
            />
          </Box>
        </AspectRatio>
      </Link>
    </Box>
  );
}
